// removed by extract-text-webpack-plugin
module.exports = {"DeliveryMapOptions":"DeliveryMapOptions__DeliveryMapOptions__36mKr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeliveryMapOptions/DeliveryMapOptions.css
// module id = 156
// module chunks = 0